/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const RedoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="#414141"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="3"
    color="#414141"
    viewBox="0 0 24 24"
  >
    <path d="M16 4l4 4-4 4"></path>
    <path d="M20 8H9.5A5.5 5.5 0 004 13.5v0A5.5 5.5 0 009.5 19H19"></path>
  </svg>
);

export const RedoIcon = (props) => <Icon component={RedoSvg} {...props} />;
